'use client'

import { useLocale as useIntlLocale } from 'next-intl'
import { DEFAULT_LOCALE, isValidLocale, type SiteLocale } from '@/lib/locale'

export type { SiteLocale } from '@/lib/locale'

export function useLocale(): SiteLocale {
  const value = useIntlLocale()
  return isValidLocale(value) ? value : DEFAULT_LOCALE
}
